import React from 'react';
import { pt } from '../services/locales/pt-BR';
import { en } from '../services/locales/en-US';

const LANG_KEY = 'rh_store_lang';

function getInitialLang() {
  // O servidor na URL tem prioridade máxima: globalusd/seasonusd → USD, globalbrl/seasonbrl → BRL
  const server = window.location.pathname.split('/')[1]?.toLowerCase() ?? '';
  if (server.includes('usd')) {
    localStorage.setItem(LANG_KEY, 'USD');
    return 'USD';
  }
  if (server.includes('brl')) {
    localStorage.setItem(LANG_KEY, 'BRL');
    return 'BRL';
  }

  // Fallback: parâmetro lang na URL (usado na SelectStore e servidores sem brl/usd no nome)
  const param = new URLSearchParams(window.location.search).get('lang');
  if (param) {
    const resolved = param.startsWith('en') ? 'USD' : 'BRL';
    localStorage.setItem(LANG_KEY, resolved);
    return resolved;
  }
  const startParams = JSON.parse(localStorage.getItem('startParams') || '{}');
  if (startParams.lang) {
    const resolved = startParams.lang.startsWith('en') ? 'USD' : 'BRL';
    localStorage.setItem(LANG_KEY, resolved);
    return resolved;
  }
  return localStorage.getItem(LANG_KEY) ?? 'BRL';
}

export const LangContext = React.createContext({ lang: 'BRL', t: pt, setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLang] = React.useState(getInitialLang);

  const handleSetLang = (newLang) => {
    localStorage.setItem(LANG_KEY, newLang);
    setLang(newLang);
  };
  const t = lang === 'BRL' ? pt : en;
  return (
    <LangContext.Provider value={{ lang, setLang: handleSetLang, t }}>
      {children}
    </LangContext.Provider>
  );
}
